export default __webpack_public_path__ + "static/media/404.5a8a3dd9.jpg";